import {
  CriteriaWithPagination,
  EuiComboBoxOptionOption,
  EuiImage,
  EuiLink,
  EuiTableSelectionType,
} from "@elastic/eui";
import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowLeft,
  IconEye,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../../_base/extension/StringExtension";
import { ParamSearchBase } from "../../../../_base/model/_base/ParamSearchBase";
import {
  editItemCollection,
  getDetailListItemCollection,
} from "../../../../api/ApiCollection";
import { getDataBrand } from "../../../../api/ApiSell";
import AppAction from "../../../../common/AppAction";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import { _localization } from "../../../../config/location";
import { getListProductCollection } from "../../../../model/CategorySpecial";
import { Brand, TblItemCommand } from "../../../../model/ProductList";
import {
  TblCollection,
  TblCollectionProduct,
} from "../../../../model/TblComboSetCollection";
import DeleteView from "./DeleteView";
import FormChooseItem from "./FormChooseItem";

const noItemsFoundMsg = "Không có kết quả tìm kiếm phù hợp...";

export interface selectedSearchOptionType {
  features?: EuiComboBoxOptionOption<string>[];
  searchType?: EuiComboBoxOptionOption<number>[];
  brandId?: EuiComboBoxOptionOption<number>[];
}

const CollectionProductList = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [dataBrand, setDataBrand] = useState<Brand[]>();
  const location = useLocation();
  const [height, setHeight] = useState(0);
  const id = location.state && location.state.id;
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [loading, setLoading] = useState(false);
  const [selectedOptions, setSelected] = useState();
  const [isSelectedItem, setSelectedItems] = useState<TblItemCommand[]>([]);

  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [productData, setProductData] = useState<getListProductCollection[]>(
    []
  );

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [numberOrderItem, setNumberOrderItem] = useState<number | null>(null);

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: "",
    },
  });

  const columns = React.useMemo<MRT_ColumnDef<getListProductCollection>[]>(
    () => [
      {
        accessorKey: "productionName",
        header: "Tên sản phẩm",
        sortable: true,
        truncateText: true,
        width: "20%",

        render: (productionName: string) => (
          <EuiLink target="_blank">{productionName}</EuiLink>
        ),
      },
      {
        accessorKey: "productCode",
        header: "Mã sản phẩm",
        sortable: true,
        truncateText: true,
        width: "7%",
      },
      {
        accessorKey: "imageUrl",
        header: "Ảnh",
        Cell: ({ row }) => {
          const imageUrl = row.original.imageUrl;
          return (
            <EuiImage
              size=""
              width={60}
              height={80}
              src={imageUrl || "/default-image.jpg"}
              alt="alt"
            />
          );
        },
      },
      {
        accessorKey: "price",
        header: "Giá bán",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "creationDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        sortingFn: (a, b) => {
          const dateA = new Date(a.original.creationDate || 0);
          const dateB = new Date(b.original.creationDate || 0);
          return dateA.getTime() - dateB.getTime();
        },
      },
      {
        accessorKey: "onhandQuantyty", //chưa có trường này trong api
        header: "Số lượng tồn kho",
        sortable: true,
        truncateText: true,
        render: (onhandQuantyty: number) => {
          return (
            <Box display={"flex"} style={{ flexDirection: "column" }}>
              <Box display={"flex"}>
                <Text>Số lượng tổng:</Text>
                <Text fw={600} style={{ color: "red", marginLeft: 4 }}>
                  {onhandQuantyty}
                </Text>
              </Box>
              <EuiLink>
                {onhandQuantyty == 0 ? (
                  <Text style={{ color: "red" }}>hết hàng</Text>
                ) : (
                  <Text style={{ color: "blue" }}>còn hàng</Text>
                )}
              </EuiLink>
            </Box>
          );
        },
      },
      {
        accessorKey: "ordering",
        header: "STT",
        Cell: ({ cell }) => {
          const ordering = cell.getValue<number | null>();
          const item = cell.row.original as getListProductCollection;
          return (
            <Box
              display={"flex"}
              onClick={() => {
                onModalEditOrderNumber(item);
              }}
            >
              <Tooltip label="Thay đổi thứ tự sản phẩm">
                <Text
                  c="blue"
                  style={{
                    cursor: "pointer",
                  }}
                  td={"underline"}
                >
                  {ordering ? ordering : 0}
                </Text>
              </Tooltip>
            </Box>
          );
        },
      },
      {
        accessorKey: "actions",
        header: "Thao tác",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => {
          const item = row.original;
          const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
          return (
            <Flex direction={"row"} gap={5} align="center">
              <Tooltip label="Xem sản phẩm">
                <ActionIcon variant="light" aria-label="Settings" color="cyan">
                  <Link to={`${hacomUrl}/${item?.url}`} target="_blank">
                    <IconEye size={20} stroke={1.5} />
                  </Link>
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Xóa sản phẩm">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="red"
                  onClick={() => deleteItem([item.id])}
                >
                  <IconTrash size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            </Flex>
          );
        },
      },
    ],
    []
  );

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const table = useMantineReactTable({
    columns,
    data: productData || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    localization: _localization,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "STT"],
        right: ["status", "actions"],
      },
      density: "xs",
    },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    state: {
      pagination,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyCellProps: () => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    positionToolbarAlertBanner: "bottom",
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const entity = {
    id: 0,
    title: "",
    config: "",
    description: "",
    status: "",
    fromTime: "",
    toTime: "",
    createdBy: "",
    lastUpdateDate: "",
    lastUpdatedBy: "",
    creationDate: "",
    parentId: null,
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
    tblComboSetCollectionModels: [],
    tblComboSetCollectionProdModels: [],
    tblComboSetCollectionCommands: [],
    tblComboSetCollectionProdCommands: [],
  };

  const form = useForm<TblCollection>({
    initialValues: {
      ...entity,
    },
    validate: {
      title: isNotEmpty("Chưa nhập tên bộ sưu tập"),
    },
  });
  const onSelectionChange = (selectedItems: getListProductCollection[]) => {
    setSelectedItems(selectedItems);
  };

  const selection: EuiTableSelectionType<getListProductCollection> = {
    selectable: (data: getListProductCollection) => true,
    selectableMessage: (selectable: boolean) =>
      !selectable ? "User is currently offline" : "",
    onSelectionChange,
  };
  function convertToVnd(amount: number): string {
    const amountStr: string = amount?.toString();
    const chunks: string[] = [];

    for (let i = amountStr?.length - 1; i >= 0; i -= 3) {
      const chunk = amountStr?.slice(Math.max(i - 2, 0), i + 1);
      chunks.push(chunk);
    }

    const result: string = chunks.reverse().join(".");
    return result;
  }
  const onTableChange = async ({
    page: { index, size },
  }: CriteriaWithPagination<any>) => {
    setPagination({ ...pagination, pageIndex: index, pageSize: size });
  };

  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event.target.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };
  const openModalDelete = () => {
    const selectedIds = Object.keys(rowSelection)
      .filter((key) => rowSelection[key])
      .map((key) => productData[parseInt(key)].id);
    if (selectedIds.length === 0) {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu để xóa!");
      return;
    } else {
      const ids = selectedIds;
      deleteItem(ids);
    }
  };
  const handleChooseItem = async (idItem: number) => {
    open();
    const dataCreate: TblCollectionProduct = {
      prodId: idItem,
      setId: id,
    };

    // Chọn phần tử thứ hai trong form
    const updatedValues = {
      ...form.values,
      tblComboSetCollectionProdCommands: [
        ...(form.values.tblComboSetCollectionProdCommands || []),
        dataCreate,
      ],
    };

    // Set giá trị mới cho form
    form.setValues(updatedValues);
    fetchDataCollection();
  };
  // List sản phẩm trong bộ sưu tập
  const fetchDataCollection = async () => {
    try {
      // Check if id exists
      if (!id) {
        console.log("Missing id for collection");
        return;
      }

      const pageSize = pagination.pageSize ?? 50;
      let query = `SpecialId=${id}&Skip=${
        pagination.pageIndex * pageSize
      }&Take=${pageSize}`;

      if (formSeachInput.getValues()?.KeySearch?.length > 0) {
        query += `&KeySearch=${formSeachInput.getValues()?.KeySearch}`;
      }

      console.log("Fetching data with query:", query);

      let callApi = await getDetailListItemCollection(query);
      console.log("API response:", callApi);

      if (!isNullOrUndefined(callApi) && !isNullOrUndefined(callApi?.data)) {
        const dataApi = callApi?.data;
        if (dataApi != null && !isNullOrUndefined(dataApi)) {
          console.log("Setting product data:", dataApi);
          setProductData(dataApi);
          form.setValues(dataApi);
          // Set row count for pagination
          setRowCount(callApi.totalCount || 0);
        } else {
          console.log("Data is null or undefined");
          NotificationExtension.Fails("Dữ liệu không tồn tại");
          modals.closeAll();
        }
      } else {
        console.log("API call failed or returned no data");
        NotificationExtension.Fails("Dữ liệu không tồn tại");
        modals.closeAll();
      }
    } catch (error) {
      console.error("Error fetching collection data:", error);
      NotificationExtension.Fails("Đã xảy ra lỗi khi tải dữ liệu");
    } finally {
      close();
    }
  };

  // Chọn sản phẩm vào bộ sưu tập
  const openModal = () =>
    modals.openConfirmModal({
      modalId: "item",
      title: (
        <>
          <div color="white">
            <Title order={5}>
              Chọn sản phẩm vào bộ sưu tập {form?.values?.title}
            </Title>
          </div>
        </>
      ),
      children: (
        <FormChooseItem
          onSearch={fetchDataCollection}
          idBST={id}
          onChooseItem={handleChooseItem}
          selectedProductIds={productData.map((item) => item.productId)}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  // Xóa sản phẩm trong bộ sưu tập
  const deleteItem = (ids: number[]) => {
    modals.openConfirmModal({
      modalId: "delete",
      title: (
        <>
          <Title order={5}>Xóa sản phẩm trong bộ sưu tập</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() => fetchDataCollection()}
          idItem={ids}
          idBST={id}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Cập nhật thứ tự sản phẩm
  const onModalEditOrderNumber = (item: getListProductCollection) => {
    let tempOrder = item?.ordering || 0; // Biến tạm để lưu giá trị STT
    modals.openConfirmModal({
      modalId: "order",
      size: "lg",
      title: (
        <>
          <Title order={5}>Cập nhật thứ tự sản phẩm</Title>
        </>
      ),
      children: (
        <>
          <Box my={10} w={"100%"}>
            <TextInput
              defaultValue={tempOrder.toString()} // Hiển thị giá trị ban đầu
              onChange={(e) => {
                tempOrder = parseInt(e.target.value) || 0; // Cập nhật giá trị tạm
              }}
              label="Thứ tự sản phẩm"
              type="text"
              w={"500px"}
            />
            <Flex
              align={"center"}
              justify={"flex-end"}
              mt={10}
              onClick={() => onhandleUpdateOrder(item, tempOrder)} // Truyền giá trị tạm
            >
              <Button>Cập nhật</Button>
            </Flex>
          </Box>
        </>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const onhandleUpdateOrder = async (
    item: getListProductCollection,
    updatedOrder: number
  ) => {
    console.log("Updated Order:", updatedOrder);
    const dataUpdate = {
      id: item?.id,
      specialCatId: id,
      productId: item?.productId,
      productCatId: item?.productCatId ?? null,
      createBy: null,
      createTime: null,
      ordering: updatedOrder, // Sử dụng giá trị mới
      creationDate: item?.creationDate ?? null,
      createdBy: null,
      lastUpdateDate: new Date().toISOString(),
      lastUpdatedBy: "",
    };
    try {
      await editItemCollection(dataUpdate);
      await fetchDataCollection();
      modals.closeAll();
    } catch (error) {
      console.log("error", error);
    }
  };

  // Tìm kiếm theo khoảng thời gian
  const handleSearchTime = (startDate: any, endDate: any) => {
    console.log("startDate", startDate);
    console.log("endDate", endDate);
  };
  useEffect(() => {
    fetchDataCollection();
  }, [id, pagination]);

  useEffect(() => {
    const fetDatabrand = async () => {
      const data = await getDataBrand();
      setDataBrand(data?.data?.lists);
    };
    fetDatabrand();
  }, []);
  const handleGoBack = () => {
    navigate("/product-manager/collection");
  };
  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
        <Flex gap={10} align="center">
          <Button leftSection={<IconArrowLeft />} onClick={handleGoBack}>
            Quay Lại
          </Button>
          <AppAction
            openModal={openModal}
            openModalDelete={openModalDelete}
            openModalCreate={openModal}
          ></AppAction>
        </Flex>
      </Flex>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchDataCollection();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchDataCollection();
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default CollectionProductList;
